module.exports = __webpack_public_path__ + "static/media/app.2bb6c8ea.svg";